import { IDropdownItem } from '../../../../../ui';
import { getValueForItem } from './getValueForItem';

export type ItemFilter<TItemType> = (
	item: TItemType,
	inputValue: string,
) => boolean;

export function getFilteredItemsForValue<TItemType extends IDropdownItem>(
	items: TItemType[],
	filter: ItemFilter<TItemType> = defaultFilter,
	value: string,
) {
	return items.filter((item) => filter(item, value));
}

export function defaultFilter<TItemType extends IDropdownItem>(
	item: TItemType,
	inputValue: string,
) {
	const itemValue = getValueForItem(item);
	const inputValueLowerCase = inputValue.toLowerCase();

	return itemValue.toLowerCase().startsWith(inputValueLowerCase);
}
